document.addEventListener("DOMContentLoaded", function () {

    console.log("ORIENT Parts Engine Loaded");

    const table = document.querySelector("#orient-parts-body");
    const detail = document.querySelector("#orient-product-detail");

    if (!table) {
        console.error("Table tidak ditemukan");
        return;
    }

    if (!detail) {
        console.error("Detail panel tidak ditemukan");
        return;
    }

    table.addEventListener("click", async function (e) {

        const row = e.target.closest(".orient-part-row");

        if (!row) return;

        table.querySelectorAll(".orient-part-row").forEach(r => {
            r.classList.remove("active");
        });

        row.classList.add("active");

        detail.innerHTML = "<p>Loading...</p>";

        const handle = row.dataset.handle;

        try {

            const response = await fetch(`/products/${handle}.js`);

            if (!response.ok) {
                throw new Error("Produk tidak ditemukan");
            }

            const product = await response.json();

            const variant = product.variants[0];

            detail.innerHTML = `

                <div class="orient-product">

                    <img src="${product.featured_image}" alt="${product.title}">

                    <h3>${product.title}</h3>

                    <p><strong>SKU :</strong> ${variant.sku || "-"}</p>

                    <p><strong>Harga :</strong>
                    ${(variant.price/100).toLocaleString("id-ID",{
                        style:"currency",
                        currency:"IDR"
                    })}
                    </p>

                    <button
                        class="orient-buy"
                        data-variant="${variant.id}">
                        Tambah ke Keranjang
                    </button>

                </div>

            `;

        } catch (err) {

            console.error(err);

            detail.innerHTML = "<p>Produk gagal dimuat.</p>";

        }

    });

    document.addEventListener("click", async function (e) {

        if (!e.target.classList.contains("orient-buy")) return;

        const variant = e.target.dataset.variant;

        try {

            await fetch("/cart/add.js", {

                method: "POST",

                headers: {
                    "Content-Type": "application/json"
                },

                body: JSON.stringify({
                    id: variant,
                    quantity: 1
                })

            });

            alert("Produk berhasil ditambahkan ke keranjang.");

        } catch (err) {

            alert("Gagal menambahkan produk.");

        }

    });

});